<template>
  <div :id="wrapperId" style="overflow: hidden;">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TableWrapper',
  components: {
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    short: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      wrapperId: '',
      wrapper: null,
      table: null,
      tableHeaders: [],
      tableRows: [],
      hiddenColumnsIndexes: [],
      running: false,
    }
  },
  computed: {
  },
  methods: {
    initData () {
      this.wrapperId = `table-wrapper-${Math.random().toString().substring(2, 5)}`
    },
    nextIndexToHide () {
      const l = this.tableHeaders.length
      for (let i = l - 2; i >= 0; i--) {
        if (!this.hiddenColumnsIndexes.includes(i)) {
          return i
        }
      }
      return -1
    },
    // Placeholder rows — "no data", "no results", the loading bar — are a single
    // cell spanning the whole table, so they have no cell per column and must be
    // skipped when columns are shown or hidden.
    columnRows () {
      return this.tableRows.filter(row => row.querySelectorAll('td').length === this.tableHeaders.length)
    },
    setColumnDisplay (rows, index, display) {
      rows.forEach(row => {
        const cell = row.querySelectorAll('td')[index]
        if (cell) {
          cell.style.display = display
        }
      })
    },
    adjustTable () {
      if (this.running) {
        return
      }
      this.running = true
      try {
        // after mobile view, Vue re-render table headers, so previously selected header are out of the DOM
        this.wrapper = document.getElementById(this.wrapperId)
        this.table = document.querySelector(`#${this.wrapperId} table`)
        if (!this.table || !this.wrapper) {
          return
        }
        this.tableHeaders = Array.from(this.table.querySelectorAll('thead th'))
        this.tableRows = Array.from(this.table.querySelectorAll('tbody tr'))

        // Table as list of cards
        if (this.$vuetify.breakpoint.xs) {
          this.tableRows.forEach((row) => {
            const chs = row.children
            for (const ch of chs) {
              ch.style.display = ''
            }
          })
          this.hiddenColumnsIndexes = []
          return
        }

        const rows = this.columnRows()

        // show all columns
        this.tableHeaders.forEach((header, index) => {
          header.style.display = ''
          this.setColumnDisplay(rows, index, '')
        })
        this.hiddenColumnsIndexes = []

        // Hide columns if table wider than wrapper
        while (this.table.offsetWidth > this.wrapper.offsetWidth && this.tableHeaders.length > 1) {
          const idx = this.nextIndexToHide()
          if (idx === -1) {
            break
          }
          this.tableHeaders[idx].style.display = 'none'
          this.setColumnDisplay(rows, idx, 'none')
          this.hiddenColumnsIndexes.push(idx)
        }
      } catch (e) {
        // Retrying here would throw again on the same DOM — that is what caused
        // the "too much recursion" crash. Leave the table unadjusted instead.
        console.warn('TableWrapper: failed to adjust table', e)
      } finally {
        this.running = false
      }
    }
  },
  mounted () {
    this.initData()
    window.addEventListener('resize', this.adjustTable)
    this.$nextTick(this.adjustTable)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.adjustTable)
  },
}
</script>
<style>
</style>
